import { render, staticRenderFns } from "./NewDigistaffDialog.vue?vue&type=template&id=35542cb5"
import script from "./NewDigistaffDialog.vue?vue&type=script&lang=js"
export * from "./NewDigistaffDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports